import React from 'react';

import Modal from 'components/cosmos/modal';
import { I18n } from 'components/translate';
import { useResendAccessContext } from 'modules/onlineEvent/context/resendAccess';

const ModalSendLater = () => {
  const { sendLaterModalIsOpen, setSendLaterModalIsOpen } =
    useResendAccessContext();

  const footer = (
    <div className="_d-flex _justify-content-end _w-full">
      <button
        className="hot-button hot-button--primary"
        onClick={() => setSendLaterModalIsOpen(false)}
      >
        <I18n label="general.ok" />
      </button>
    </div>
  );

  return (
    <Modal
      open={sendLaterModalIsOpen}
      onClose={() => setSendLaterModalIsOpen(false)}
      footer={footer}
    >
      <>
        <h6 className="_mb-5 _text-3">
          <I18n label="online_event.resend_access.modal_send_later.title" />
        </h6>
        <I18n
          label="online_event.resend_access.modal_send_later.description"
          html
        />
      </>
    </Modal>
  );
};

export default ModalSendLater;
